var logo = "Logos-module_logo__i-hzL";

export { logo };
